import React, { FC, PropsWithChildren, createContext, useContext, useMemo } from 'react';

import type { useTheme } from 'styled-components';

import { Theme } from '../theme';

export type BaseContextTypes = {
  useTheme: typeof useTheme;
};

const BaseContext = createContext<BaseContextTypes | null>(null);

export const useCustomTheme = () => {
  const context = useContext(BaseContext);

  if (!context) {
    throw new Error('useCustomTheme needs to be in a BaseProvider.');
  }

  return context.useTheme() as Theme;
};

export const BaseProvider: FC<PropsWithChildren<BaseContextTypes>> = ({ useTheme, children }) => {
  const value = useMemo(() => ({ useTheme }), []);

  return <BaseContext.Provider value={value}>{children}</BaseContext.Provider>;
};
